<template>
  <div>
    <div class="text-subtitle mb-4">Modifier les informations des courses.</div>
    <div v-if="data_loaded">
      <ConfigCourseItem v-for="course in list_courses.list" :key="course.id" :item="course"></ConfigCourseItem>
    </div>

    <v-row>
      <v-col>
        <v-btn color="primary-dark" @click="update_config()" :loading="loading" class="mt-4" block>Enregistrer les
          modifications</v-btn>
      </v-col>
    </v-row>
    <div v-if="mainStore.authAdmin.isSportipsAdmin">
      <hr />

      <div class="text-h6">Historique des modifications</div>
      <ConfigHistory v-if="list_courses.id_module" action="config_courses" :id="list_courses.id_module"
        :key="lastFetch"></ConfigHistory>
    </div>
    <v-snackbar v-model="show_snackbar" location="top right" color="dark-green">
      Mise à jour effectuée avec succès !

      <template v-slot:actions>
        <v-btn color="white" variant="text" @click="show_snackbar = false"> Fermer </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import List_Courses from "@/classes/Courses/List_Courses.class";
import ConfigHistory from "@/components/Administration/ConfigurationModule/ConfigHistory.vue";
import ConfigCourseItem from "@/components/Administration/ConfigurationModule/Config_Courses/Course_Item.vue";

export default {

  components: { ConfigHistory, ConfigCourseItem },
  data() {
    return {
      list_courses: new List_Courses(),
      data_loaded: false,
      loading: false,
      show_snackbar: false,
      lastFetch: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async update_config() {
      this.loading = true;
      await this.list_courses.update_config();
      this.loading = false;
      this.show_snackbar = true;
      this.lastFetch = this.$moment().format("YYYY-MM-DD HH:mm:ss");
    },
  },
  async mounted() {
    this.list_courses.id_module = this.mainStore.module.id;
    await this.list_courses.fetch_all();
    this.data_loaded = true;
  },
};
</script>

<style lang="sass" scoped>
</style>